<div class="header-navigation-back">
    <mat-icon (click)="onNavigateBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
    <span class="title">Filter Shipments</span>
</div>
<div class="filter-content">
    <form [formGroup]="filterForm">
        <!-- Availability From -->
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Pickup from</mat-label>
                <input matInput readonly [matDatepicker]="fromDatePicker"
                 (click)="fromDatePicker.open()" formControlName="fromDate"  (dateChange)="onDateChangeEvent($event, 'fromDate')" />
                <mat-datepicker-toggle matSuffix [for]="fromDatePicker" data-test="from-date-form-field"></mat-datepicker-toggle>
                <mat-datepicker #fromDatePicker></mat-datepicker>
            </mat-form-field>
        </div>
         <!-- Availability To -->
         <div>
            <mat-form-field appearance="outline">
                <mat-label>Pickup to</mat-label>
                <input 
                 matInput 
                 readonly 
                 [matDatepicker]="toDatePicker" 
                 formControlName="toDate" 
                 (dateChange)="onDateChangeEvent($event, 'toDate')"
                 [min]="fromDate?.value"
                 (click)="toDatePicker.open()" 
                />
                <mat-datepicker-toggle matSuffix [for]="toDatePicker" data-test="to-date-form-field"></mat-datepicker-toggle>
                <mat-datepicker #toDatePicker></mat-datepicker>
            </mat-form-field>
        </div>
         <!-- Status -->
         <div>
            <mat-form-field appearance="outline">
                <mat-label>Status</mat-label>
                <input matInput formControlName="status" readonly (click)="onOpenStatusActionSheet()" data-test="status-field"/>
            </mat-form-field>
        </div>
         <!-- Pickup -->
         <div>
            <mat-form-field class="full-width" appearance="outline">
                <mat-label>Pick Up</mat-label>
                <input matInput #pickUpText formControlName="pickUp" 
                [value]="pickUp" data-test="pickUp-form-field" name="pickUp" (change)="onAddressChange($event, 'pickUp')"/>
            </mat-form-field>
        </div>
         <!-- Drop -->
         <div>
            <mat-form-field class="full-width" appearance="outline">
                <mat-label>Drop Off</mat-label>
                <input matInput #dropText formControlName="dropOff" [value]="dropOff" name="dropOff"
                data-test="drop-form-field" (change)="onAddressChange($event, 'dropOff')"/>
            </mat-form-field>
        </div>
        <!-- Load Size -->
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Load Size</mat-label>
                <input matInput formControlName="loadSize" readonly (click)="onOpenLoadSizeActionSheet()" data-test="load-size-field"/>
            </mat-form-field>
        </div>
        <div class="button-container">
            <button mat-raised-button class="btn-accept" [disabled]="!filterForm.valid" type="button" (click)="onApplyFilters()" data-test="apply-button">Apply</button>
            <button mat-raised-button class="btn-clear" (click)="onClearFilters()" data-test="clear-filter-button">Clear filters</button>
        </div>
    </form>
</div>